var _rect, _rect2, _circle, _circle2, _circle3, _circle4, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockTimer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.73438,
    y: 7.875,
    width: 1.75,
    height: 6.23438,
    rx: 0.875,
    transform: "rotate(90 9.73438 7.875)",
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.875,
    y: 12.25,
    width: 1.75,
    height: 7.875,
    rx: 0.875,
    transform: "rotate(90 7.875 12.25)",
    fill: "#C4C4C4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 14,
    r: 14,
    fill: "#FFB719"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.0273,
    cy: 13.9727,
    r: 11.6211,
    fill: "#E38C00"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.0273,
    cy: 13.918,
    r: 9.65234,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.0273,
    cy: 13.918,
    r: 1.50391,
    fill: "#4B4B58"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4376 13.5C26.8863 13.5 27.25 13.8637 27.25 14.3124V14.3124C27.25 14.7611 26.8863 15.1248 26.4376 15.1248L21.3124 15.1248C20.8637 15.1248 20.5 14.7611 20.5 14.3124V14.3124C20.5 13.8637 20.8637 13.5 21.3124 13.5L26.4376 13.5Z",
    fill: "#616171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8.75C20 8.33579 20.3358 8 20.75 8V8C21.1642 8 21.5 8.33579 21.5 8.75V14.25C21.5 14.6642 21.1642 15 20.75 15V15C20.3358 15 20 14.6642 20 14.25V8.75Z",
    fill: "#737386"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockTimer);
export default __webpack_public_path__ + "static/media/ClockTimer.8d92cf2eec190e80cfe772bb2a8e48a4.svg";
export { ForwardRef as ReactComponent };